export const evenAnimationMixin = {
	methods: {
		evenAnimation (i, even, odd) {
			return i % 2 === 0 ? even : odd
		}
	}
}
